import { render, staticRenderFns } from "./add-GST.vue?vue&type=template&id=53c055bb&"
import script from "./add-GST.vue?vue&type=script&lang=js&"
export * from "./add-GST.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports